<template>
  <v-menu offset-y>
    <v-btn slot="activator" icon :loading="loading" class="ml-2">
      <v-icon>language</v-icon>
      <span class="ml-1">{{ currentLocale.toUpperCase() }}</span>
    </v-btn>
    <v-list>
      <v-list-tile
        v-for="lang in languages"
        :key="lang.code"
        @click="changeLanguage(lang.code)"
        :disabled="loading || currentLocale === lang.code"
      >
        <v-list-tile-title>{{ lang.name }}</v-list-tile-title>
        <v-list-tile-action v-if="currentLocale === lang.code">
          <v-icon color="primary">check</v-icon>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { autoTranslate } from '@/plugins/i18n'

export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      loading: false,
      languages: [
        { code: 'en', name: 'English' },
        { code: 'fr', name: 'Français' }
      ]
    }
  },
  computed: {
    currentLocale() {
      return autoTranslate.getLanguage()
    }
  },
  methods: {
    changeLanguage(lang) {
      if (this.loading || lang === this.currentLocale) return

      this.loading = true

      console.log(`🌐 Changing to ${lang}...`)

      // Sauvegarder la langue
      autoTranslate.setLanguage(lang)

      // Message
      const msg = lang === 'en'
        ? 'Language changed to English. Reloading...'
        : 'Langue changée en Français. Rechargement...'

      this.$store.commit('setSnackBarMessage', msg)
      this.$store.commit('setSnackBarColor', 'teal darken-4')
      this.$store.commit('activateSnackBar', true)

      // Recharger la page
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    }
  }
}
</script>